import CSliderThumb, { CVerticalThumb } from './CSliderThumb';

export { CVerticalThumb };

export default CSliderThumb;
